import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "./step/stepform.css";
import App from "./App";
import Otp from "./Otp";
import Home from "./Home";
import reportWebVitals from "./reportWebVitals";
import { GlobalProvider } from "./GlobalContext.js";
import OnBoarding from "./OnBoarding";
import ResetPassword from "./ResetPassword";
import ChangePassword from "./ChangePassword";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GlobalProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/otp" element={<Otp />} />
        <Route path="/home" element={<Home />} />
        <Route path="/onboarding" element={<OnBoarding />} />
        <Route path="/resetpassword" element={<ResetPassword />} />
        <Route path="/changepassword" element={<ChangePassword />} />
      </Routes>
    </BrowserRouter>
  </GlobalProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
